import { render, staticRenderFns } from "./deliveryTypeSelect.vue?vue&type=template&id=5a9d2ab2"
import script from "./deliveryTypeSelect.vue?vue&type=script&lang=js"
export * from "./deliveryTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports